export default __webpack_public_path__ + "static/media/SearchIcon.54e65e94.svg";